/**
 * Masks an account ID by replacing all but the last 3 characters with bullet characters ('•')
 * @param accountId The account ID to mask
 * @returns The masked account ID string
 */
export function maskAccountId(accountId: string | undefined): string {
  if (!accountId) return ''
  if (accountId.length <= 3) return accountId
  return `•••••${accountId.slice(-3)}`
}
